module.exports = __webpack_public_path__ + "img/tour-free_pr695.6dd3bad1.png";